import { render } from "./News.vue?vue&type=template&id=40f1483a"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/News.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40f1483a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40f1483a', __exports__)) {
    api.reload('40f1483a', __exports__)
  }
  
  module.hot.accept("./News.vue?vue&type=template&id=40f1483a", () => {
    api.rerender('40f1483a', render)
  })

}


export default __exports__